import { ComponentType, FunctionComponent } from 'react';

import { DataTableCellProps } from 'components/dataTable/dataTable.types';

import { COLUMN_IDS } from '../../keys';
import { ActionCell } from './action';
import { AmountCell } from './amount';
import { DateCell } from './date';
import { DefaultCell } from './default';
import { IdCell } from './id';
import { StatusCell } from './status';
import { TypeCell } from './type';

const cellComponentMap: { [key: string]: ComponentType<DataTableCellProps> } = {
  [COLUMN_IDS.TYPE]: TypeCell,
  [COLUMN_IDS.SOURCE_ID]: IdCell,
  [COLUMN_IDS.AMOUNT]: AmountCell,
  [COLUMN_IDS.CREATED_AT]: DateCell,
  [COLUMN_IDS.STATUS]: StatusCell,
  [COLUMN_IDS.BALANCE]: AmountCell,
  [COLUMN_IDS.ACTIONS]: ActionCell,
  default: DefaultCell,
};

export const RefundAccountCell: FunctionComponent<DataTableCellProps> = (props) => {
  const { column } = props;

  const SelectedComponent = cellComponentMap[column.id] || cellComponentMap.default;

  return <SelectedComponent {...props} />;
};
